module.exports = __webpack_public_path__ + "media/images/placeholder-aa6273ca7939886a3c267aa29593ca55.png";